import React, { useState, useEffect, useCallback } from 'react';

let logoutTimer;

const AuthContext = React.createContext({
  token: '',
  userId: '',
  orgId: '',
  customerId: '',
  paymentMethodId: '',
  userName: '',
  email: '',
  scope: '',
  configureUrl: '',
  isLoggedIn: false,
  login: (token, userId, orgId, customerId, paymentMethodId, userName, email, scope, tokenExpiration) => {},
  logout: () => {},
  setConfigureUrl: (url) => {},
});

const calculateRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();
  return adjExpirationTime - currentTime;
};

const retrieveStoredToken = () => {
  const storedToken = localStorage.getItem('token');
  const storedTokenExpiration = localStorage.getItem('tokenExpiration');

  if (!storedToken || !storedTokenExpiration) return null;

  const remainingTime = calculateRemainingTime(storedTokenExpiration);

  if (remainingTime <= 1000) {
    localStorage.clear();
    return null;
  }

  return { token: storedToken, duration: remainingTime };
};

export const AuthContextProvider = (props) => {
  const tokenData = retrieveStoredToken();
  let initialToken = tokenData?.token;
  const initialUserId = localStorage.getItem('userId');
  const initialCustomerId = localStorage.getItem('customerId');
  const initialPaymentMethodId = localStorage.getItem('paymentMethodId');
  const initialUserName = localStorage.getItem('userName');
  const initialEmail = localStorage.getItem('email');
  const initialScope = localStorage.getItem('scope');
  const initialOrgId = localStorage.getItem('orgId');
  const initialConfigureUrl = localStorage.getItem('configureUrl');
  const initialFirstName = localStorage.getItem('firstname');

  const [token, setToken] = useState(initialToken);
  const [userId, setUserId] = useState(initialUserId);
  const [customerId, setCustomerId] = useState(initialCustomerId);
  const [paymentMethodId, setPaymentMethodId] = useState(initialPaymentMethodId);
  const [userName, setUserName] = useState(initialUserName);
  const [email, setEmail] = useState(initialEmail);
  const [scope, setScope] = useState(initialScope);
  const [orgId, setOrgId] = useState(initialOrgId);
  const [configureUrl, setConfigureUrl] = useState(initialConfigureUrl);
  const [firstName, setFirstName] = useState(initialFirstName);

  const userIsLoggedIn = !!token;

  const logoutHandler = useCallback(() => {
    setToken(null);
    setUserId(null);
    setCustomerId(null);
    setPaymentMethodId(null);
    setUserName(null);
    setEmail(null);
    setScope(null);
    setOrgId(null);

    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiration');
    localStorage.removeItem('userId');
    localStorage.removeItem('customerId');
    localStorage.removeItem('paymentMethodId');
    localStorage.removeItem('userName');
    localStorage.removeItem('email');
    localStorage.removeItem('scope');
    localStorage.removeItem('orgId');

    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  }, []);

  useEffect(() => {
    if (tokenData) {
      logoutTimer = setTimeout(logoutHandler, tokenData.duration);
    }
  }, [tokenData, logoutHandler]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'token') {
        const newToken = event.newValue;
        if (!newToken) {
          logoutHandler();
        } else {
          window.location.reload();
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [logoutHandler]);

  const loginHandler = (token, userId, orgId, userName, email, scope, tokenExpiration) => {
    console.log("userNameinlognHandler" , userName)
    setUserId(userId);
    setUserName(userName);
    setEmail(email);
    setScope(scope);
    setOrgId(orgId);
    setToken(token);

    localStorage.setItem('token', token);
    localStorage.setItem('tokenExpiration', tokenExpiration);
    localStorage.setItem('userId', userId?.toString());
    localStorage.setItem('userName', userName);
    console.log("userNameIncontext" , userName)
    localStorage.setItem('email', email);
    localStorage.setItem('scope', scope);
    localStorage.setItem('orgId', orgId);

    const remainingTime = calculateRemainingTime(tokenExpiration);
    logoutTimer = setTimeout(logoutHandler, remainingTime);
  };

  const setConfigureUrlHandler = (url) => {
    setConfigureUrl(url);
    localStorage.setItem('configureUrl', url);
  };

  const handleCustomerId = ( customerId ) => {
    setCustomerId(customerId);
    localStorage.setItem('customerId', customerId);
  }

  const handlePaymentMethodId = ( paymentMethodId ) => {
    setPaymentMethodId(paymentMethodId)
    localStorage.setItem('paymentMethodId', paymentMethodId)
  }

  console.log("paymentMethodId", paymentMethodId)

  const contextValue = {
    token,
    userId,
    orgId,
    setOrgId,
    customerId,
    paymentMethodId,
    userName,
    email,
    scope,
    configureUrl,
    isLoggedIn: userIsLoggedIn,
    addCustomerId: handleCustomerId,
    addPaymentMethodId: handlePaymentMethodId,
    login: loginHandler,
    logout: logoutHandler,
    setConfigureUrl: setConfigureUrlHandler,
    firstName,
  };

  return <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>;
};

export default AuthContext;
